import { lazy } from 'react'

export const WorkSchedule = lazy(() => import('./WorkSchedule'))
